exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map[data-v-68d426e8]{width:60vw;height:80vh}@media (max-width:1300px){#map[data-v-68d426e8]{margin:auto;width:75vw}}@media (max-width:1000px){#map[data-v-68d426e8]{margin:auto;width:85vw}}@media (max-width:790px){#map[data-v-68d426e8]{margin:auto;width:90vw}}@media (max-width:720px){#map[data-v-68d426e8]{margin:auto;width:95vw}}", ""]);

// exports
